import { consola } from 'consola'
import { apiNotification } from '@/entities/notification'

const logger = consola.withTag('unread-notifications')

const unreadCount = ref(0)
const isLoading = ref(false)
const lastFetchTime = ref<number | null>(null)
const FETCH_INTERVAL = 5 * 60 * 1000

export const useUnreadNotifications = () => {
  const fetchUnreadCount = async (force = false): Promise<void> => {
    if (isLoading.value && !force) return
    if (!force && lastFetchTime.value && Date.now() - lastFetchTime.value < FETCH_INTERVAL) return
    try {
      isLoading.value = true
      const response = await apiNotification.getNotifications({ limit: 1, offset: 0 })
      unreadCount.value = response.stats.unread
      lastFetchTime.value = Date.now()
    } catch (error) {
      logger.error('Ошибка при загрузке количества непрочитанных уведомлений:', error)
    } finally {
      isLoading.value = false
    }
  }

  const decreaseUnreadCount = (amount = 1): void => {
    unreadCount.value = Math.max(0, unreadCount.value - amount)
  }

  const clearUnreadCount = (): void => {
    unreadCount.value = 0
  }

  const reset = (): void => {
    unreadCount.value = 0
    isLoading.value = false
    lastFetchTime.value = null
  }

  const hasUnread = computed(() => unreadCount.value > 0)
  const unreadDisplay = computed(() => unreadCount.value > 99 ? '99+' : String(unreadCount.value))

  return {
    unreadCount, isLoading,
    hasUnread, unreadDisplay,
    fetchUnreadCount, decreaseUnreadCount, clearUnreadCount, reset,
  }
}
